module.exports = __webpack_public_path__ + "fonts/MyriadPro-SemiBold.86bb1295.otf";